<!-- 创建时间2023/06/14 18:43:34 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述：创建表单-分类选择 -->
<template>
  <div class="yxtbiz-flex-center">
    <yxt-select class="yxtbiz-flex-1" ref="select" v-model="name" :disabled="disabled" @visible-change="visibleChange">
      <div
        slot="empty"
        class="yxtbiz-kng-operator__catalog-tree"
        v-loading="catalogData.loading"
      >
        <yxt-input
          v-model="catalogFilterValue"
          class="mb8"
          :placeholder="
            $t('pc_kng_kngcourse_msg_pea4' /* 请输入课程分类名称搜索 */)
          "
          searchable
          autofocus
        ></yxt-input>
        <yxt-tree v-if="showTree"
          ref="tree"
          virtual
          node-key="id"
          :expand-on-click-node="false"
          :data="catalogData.tree"
          :filter-node-method="filterNode"
          :current-node-key="id"
          :default-expanded-keys="[id]"
          @node-click="clickTreeNode"
        />
      </div>
    </yxt-select>
    <yxt-button v-if="enableAddCatalog" :disabled="disabled" class="ml12" @click="add">{{ $t('pc_kng_catalogmgmt_btn_add'/** 新增分类 */) }}</yxt-button>
  </div>
</template>

<script>

export default {
  name: 'form-catalog',
  inject: ['getCatalogData', 'getEnableAddCatalog'],
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      catalogFilterValue: '',
      showTree: false // 防止开启虚拟滚动后，再次打开空白问题
    };
  },
  computed: {
    catalogData() {
      return this.getCatalogData();
    },
    enableAddCatalog() {
      return this.getEnableAddCatalog();
    }
  },
  watch: {
    catalogFilterValue(val) {
      this.$refs.tree && this.$refs.tree.filter(val);
    }
  },
  methods: {
    // 分类树筛选的方法
    filterNode(value, data) {
      if (!value) return true;
      const name = data.label.toLowerCase();
      const val = value.toLowerCase();
      return name.indexOf(val) !== -1;
    },
    // 点击树的节点的事件
    clickTreeNode(obj) {
      if (this.catalogData.tree.some(item => item.id === obj.id)) return;
      this.update(obj);
      // 隐藏下拉
      this.$refs.select.visible = false;
    },
    update(obj) {
      this.$emit('update:id', obj.id);
      this.$emit('update:name', obj.label);
    },
    visibleChange(val) {
      if (val) {
        this.showTree = true;
      } else {
        setTimeout(() => {
          this.showTree = false;
        }, 300);
      }
    },
    add() {
      this.$root.$emit('ADD_CATALOG', this.info);
    }
  }
};
</script>